// Layout.tsx
import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { cn } from "@/utils/utils";
import { AppSidebar } from "./AppSideBar";
import { MobileNav } from "./MobileNav";
import { TooltipProvider } from "@/components/ui/tooltip";

export function Layout() {
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth < 768);
        checkMobile();
        window.addEventListener("resize", checkMobile);
        return () => window.removeEventListener("resize", checkMobile);
    }, []);

    return (
        <TooltipProvider>
            <div className="min-h-screen bg-background">
                {/* Desktop Sidebar */}
                {!isMobile && (
                    <AppSidebar
                        collapsed={sidebarCollapsed}
                        onToggle={() => setSidebarCollapsed((v) => !v)}
                    />
                )}

                {/* Main Content */}
                <main
                    className={cn(
                        "min-h-screen transition-all duration-300 ease-in-out",
                        !isMobile && (sidebarCollapsed ? "ml-16" : "ml-64"),
                        "print:ml-0", // ⬅️ КЛЮЧЕВО: убираем пустое место слева при печати
                        isMobile && "pb-20"
                    )}
                >
                    <div className={cn("p-4 md:p-6 lg:p-8", "print:p-20")}>
                        <Outlet />
                    </div>
                </main>

                {/* Mobile Navigation */}
                {isMobile && <MobileNav />}
            </div>
        </TooltipProvider>
    );
}
